import type { MultiSelectCardsProps } from '../../types';

export default function MultiSelectCards({
  options,
  value,
  onChange,
  maxSelections,
  className = '',
}: MultiSelectCardsProps) {
  function handleToggle(optionId: string) {
    if (value.includes(optionId)) {
      onChange(value.filter((id) => id !== optionId));
    } else {
      if (maxSelections && value.length >= maxSelections) {
        return;
      }
      onChange([...value, optionId]);
    }
  }

  return (
    <div className={`multi-select-grid ${className}`}>
      {options.map((option) => {
        const isSelected = value.includes(option.id);
        const isDisabled = maxSelections && !isSelected && value.length >= maxSelections;

        return (
          <button
            key={option.id}
            type="button"
            className={`selectable-card selectable-card--multi ${isSelected ? 'selectable-card--selected' : ''} ${isDisabled ? 'selectable-card--disabled' : ''}`}
            onClick={() => handleToggle(option.id)}
            disabled={isDisabled || false}
          >
            {option.icon && (
              <span className="selectable-card__icon">{option.icon}</span>
            )}
            <div className="selectable-card__content">
              <span className="selectable-card__title">{option.title}</span>
              {option.description && (
                <span className="selectable-card__description">{option.description}</span>
              )}
            </div>
            <span className="selectable-card__indicator" aria-hidden="true" />
          </button>
        );
      })}
    </div>
  );
}
